import React, { Component } from 'react';

import API from '@api';

import Triage from '@triage-help/components/triage';
import Text from '@triage-help/components/text';
import Progression from '@triage-help/components/progression';
import Location from '@triage-help/components/location';
import Confirmation from '@triage-help/components/confirmation';
import ChannelSelection from '@triage-help/components/channel-selection';
import Checker from '@triage-help/components/checker';
import AutoRetune from '@triage-help/components/auto-retune';
import Manual from '@triage-help/components/manual';
import ConfirmCheckbox from '@triage-help/components/confirm-checkbox';

const getComponent = (
  step,
  goToStep,
  goToPrev,
  stateUpdateFunctions,
  state,
) => {
  if (!step) {
    return null;
  }

  switch (step.component) {
    case 'triage':
      return (
        <Triage
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
        />
      );
    case 'text':
      return (
        <Text
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
        />
      );
    case 'progression':
      return (
        <Progression
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
        />
      );
    case 'location':
      return (
        <Location
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          updateLocation={stateUpdateFunctions.location}
          location={state.location}
        />
      );
    case 'confirmation':
      return (
        <Confirmation
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
          channels={state.channels}
          updateStatus={stateUpdateFunctions.status}
        />
      );
    case 'channel':
      return (
        <ChannelSelection
          step={step}
          goToStep={goToStep}
          updateChannels={stateUpdateFunctions.channels}
          location={state.location}
        />
      );
    case 'status_checker':
      return (
        <Checker
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          status={state.status}
          location={state.location}
        />
      );
    case 'manual':
      return (
        <Manual
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
          selectedBrand={state.selectedBrand}
          handleUpdatedBrand={stateUpdateFunctions.brand}
        />
      );
    case 'auto_retune':
      return (
        <AutoRetune
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
          selectedBrand={state.selectedBrand}
          handleUpdatedBrand={stateUpdateFunctions.brand}
        />
      );
      return;
    case 'confirm_checkbox':
      return (
        <ConfirmCheckbox
          step={step}
          goToStep={goToStep}
          goToPrev={goToPrev}
          location={state.location}
        />
      );
    default:
      return null;
  }
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: null,
      location: null,
      channels: [],
      status: null,
      steps: [],
      history: [],
      selectedBrand: undefined,
    };

    API.getTriage(props.target).then(
      (data => {
        this.setState({
          steps: data.steps,
          step: data.steps.find(s => s.id == data.config.start),
          history: [data.config.start],
        });
        window.location.hash = data.config.start;
        ga('send', 'pageview', window.location.pathname + window.location.hash);
      }).bind(this),
    );
  }

  getRoute(id) {
    return this.state.steps.find(element => element.id === id);
  }

  handleChangeCurrentStep(id) {
    this.setState(prevState => {
      return {
        step: this.getRoute(id),
        history: [...prevState.history, id],
      };
    });
    window.location.hash = id;
    $(window).scrollTop(0);
    ga('send', 'pageview', window.location.pathname + window.location.hash);
  }

  handleChangePreviousStep() {
    const prevId =
      this.state.history[this.state.history.length - 2] ||
      this.state.history[this.state.history.length - 1];

    const newHistory = [...this.state.history];
    newHistory.pop();

    this.setState({
      step: this.getRoute(prevId),
      history: newHistory,
    });

    window.location.hash = prevId;
    $(window).scrollTop(0);
    ga('send', 'pageview', window.location.pathname + window.location.hash);
  }

  updateBrand(brand) {
    if (brand !== this) {
      this.setState({
        selectedBrand: brand,
      });
    }
  }

  updateChannels(channels) {
    this.setState({
      channels: channels,
    });
  }

  updateLocation(location) {
    this.setState({
      location: location,
    });
  }

  updateStatus(status) {
    this.setState({
      status: status,
    });
  }

  render() {
    const stepComponent = getComponent(
      this.state.step,
      this.handleChangeCurrentStep.bind(this),
      this.handleChangePreviousStep.bind(this),
      {
        channels: this.updateChannels.bind(this),
        location: this.updateLocation.bind(this),
        status: this.updateStatus.bind(this),
        brand: this.updateBrand.bind(this),
      },
      this.state,
    );

    return <div className="fv-triage-help">{stepComponent}</div>;
  }
}

export default App;
